import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img src="/PAYXB.png" alt="PayXB Logo" className="h-40 w-auto logo-invert rounded-xl object-contain" />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-black hover:text-gray-600 transition-colors">Features</a>
            <a href="#benefits" className="text-black hover:text-gray-600 transition-colors">Benefits</a>
            <a href="#products" className="text-black hover:text-gray-600 transition-colors">Products</a>
            <a href="#testimonials" className="text-black hover:text-gray-600 transition-colors">Testimonials</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a href="https://tally.so/r/3ykrZ6" className="btn-primary">
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 